import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag, Check } from "lucide-react";

const PURCHASES = [
  ["Emily", "Perth"], ["Sophie", "Gold Coast"], ["Olivia", "Sydney"], ["Charlotte", "Melbourne"],
  ["Ava", "Brisbane"], ["Mia", "Adelaide"], ["Isla", "Byron Bay"], ["Grace", "Noosa"],
  ["Chloe", "Newcastle"], ["Ruby", "Geelong"], ["Zoe", "Cairns"], ["Lily", "Hobart"],
];

const ITEMS = ["Leopard Luxe™ LED Light Therapy Mask", "The Glow Duo", "The Complete Glow Ritual"];

// Subtle bottom-left "recent purchase" social-proof popups.
export const SocialProof = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let visible = false;
    const fire = () => {
      if (visible) return;
      const [name, loc] = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      const item = ITEMS[Math.floor(Math.random() * ITEMS.length)];
      const mins = Math.floor(Math.random() * 38) + 2;
      visible = true;
      setData({ name, loc, item, mins, id: Date.now() });
      setTimeout(() => { setData(null); visible = false; }, 5200);
    };
    const first = setTimeout(fire, 7000);
    const interval = setInterval(fire, 19000);
    return () => { clearTimeout(first); clearInterval(interval); };
  }, []);

  return (
    <div className="pointer-events-none fixed bottom-5 left-5 z-[70] hidden md:block">
      <AnimatePresence>
        {data && (
          <motion.div
            key={data.id}
            data-testid="social-proof-toast"
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="pointer-events-auto flex w-[320px] items-center gap-3 rounded-2xl border border-[#F2E8E6] bg-white/95 p-3 shadow-[0_18px_40px_-20px_rgba(44,43,44,0.35)] backdrop-blur"
          >
            <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-[#FFFCFA]">
              <ShoppingBag className="h-4 w-4 text-[#FBC4A8]" />
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-[#2C2B2C]">{data.name} in {data.loc} just ordered</p>
              <p className="truncate text-xs text-[#9A8E88]">{data.item} · {data.mins} min ago</p>
            </div>
            <Check className="h-4 w-4 flex-none text-[#4A5D4E]" strokeWidth={2.5} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
